export default __webpack_public_path__ + "static/media/kid04.f5ae28c7.jpg";